/**
 * mi-comunidad
 * Version 2.0 de la comunidad
 *
 * The version of the OpenAPI document: 2.54.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { VacationRequestsControllerUploadInitialBalances200ResponseDataResultsInner } from './vacationRequestsControllerUploadInitialBalances200ResponseDataResultsInner';
import { DepartmentReportControllerImportDepartmentsFromExcel200ResponseDataErrorsInner } from './departmentReportControllerImportDepartmentsFromExcel200ResponseDataErrorsInner';


export interface VacationRequestsControllerUploadInitialBalances200ResponseData { 
    totalRows?: number;
    successCount?: number;
    errorCount?: number;
    parseErrors?: Array<DepartmentReportControllerImportDepartmentsFromExcel200ResponseDataErrorsInner>;
    results?: Array<VacationRequestsControllerUploadInitialBalances200ResponseDataResultsInner>;
}

